import { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useInstantSearch } from 'react-instantsearch-hooks-web';

export const NoResultsBoundary = ({ children, fallback, type }) => {
  const { results } = useInstantSearch();
  const [noValidResults, setNoValidResults] = useState(false);

  useEffect(() => {
    if (
      type === 'credit_key_applications' &&
      !results?.hits?.find((r) => r.company_id)
    )
      setNoValidResults(true);
  }, [results]);


  if (!results.__isArtificial && (results.nbHits === 0 || noValidResults)) {
    // The `__isArtificial` flag makes sure not to display the No Results message
    // when no hits have been returned yet.
    return (
      <>
        {fallback}
        <div hidden>{children}</div>
      </>
    );
  }

  return children;
};

export const NoResults = ({ query, type, noIndexResults }) => {
  return (
    <p className={classnames({ 'hidden': !noIndexResults })}>
      No matching {type} results for <q>{query}</q>.
    </p>
  );
};
